import { extraProducts } from './products-extra';

export interface Product {
  id: string;
  name: string;
  slug: string;
  description: string;
  price: number;
  salePrice: number | null;
  sku: string;
  stock: number;
  categoryId: string;
  categoryName: string;
  storeName: string;
  brand: string;
  images: string[];
  rating: number;
  reviewCount: number;
  featured: boolean;
  flashDeal: boolean;
  flashDealEnds: string | null;
  soldCount: number;
  createdAt: string;
  tags: string[];
}

export const products: Product[] = [
  {
    id: 'p1',
    name: 'Samsung Galaxy S24 Ultra 256GB - Titanium Gray',
    slug: 'samsung-galaxy-s24-ultra-256gb',
    description: 'The most powerful Galaxy yet. 200MP camera, AI features, titanium frame.',
    price: 184999,
    salePrice: 169999,
    sku: 'SAM-S24U-256-TG',
    stock: 45,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%20Galaxy%20S24%20Ultra%20smartphone%20in%20titanium%20gray%20color%2C%20front%20and%20back%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-s24-01&orientation=squarish',
    ],
    rating: 4.8,
    reviewCount: 342,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1247,
    createdAt: '2026-01-15',
    tags: ['smartphone', 'flagship', 'android', 'smartphones', 'samsung'],
  },
  {
    id: 'p2',
    name: 'Apple iPhone 15 Pro Max 512GB - Natural Titanium',
    slug: 'apple-iphone-15-pro-max-512gb',
    description: 'A17 Pro chip, titanium design, 48MP camera system.',
    price: 219999,
    salePrice: null,
    sku: 'APL-15PM-512-NT',
    stock: 32,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'iStore Kenya',
    brand: 'Apple',
    images: [
      'https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20in%20natural%20titanium%20color%2C%20front%20and%20back%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-iphone-01&orientation=squarish',
    ],
    rating: 4.9,
    reviewCount: 512,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2890,
    createdAt: '2026-02-01',
    tags: ['smartphone', 'flagship', 'ios', 'apple', 'smartphones'],
  },
  {
    id: 'p3',
    name: 'Sony WH-1000XM5 Wireless Noise Cancelling Headphones',
    slug: 'sony-wh1000xm5-headphones',
    description: 'Industry-leading noise cancellation with 30-hour battery life.',
    price: 45999,
    salePrice: 37999,
    sku: 'SNY-WH1000XM5-BK',
    stock: 78,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'AudioWorld Kenya',
    brand: 'Sony',
    images: [
      'https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20wireless%20noise%20cancelling%20headphones%20in%20black%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-sony-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 189,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 567,
    createdAt: '2026-03-10',
    tags: ['headphones', 'wireless-headphones', 'noise-cancelling', 'audio', 'bluetooth'],
  },
  {
    id: 'p4',
    name: 'LG 55-inch 4K UHD Smart TV - WebOS',
    slug: 'lg-55inch-4k-smart-tv',
    description: 'Stunning 4K display with AI Picture Pro and ThinQ AI.',
    price: 89999,
    salePrice: 74999,
    sku: 'LG-55UHD-WEBOS',
    stock: 23,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'TechHub Kenya',
    brand: 'LG',
    images: [
      'https://readdy.ai/api/search-image?query=LG%2055%20inch%20flat%20screen%204K%20UHD%20smart%20TV%2C%20front%20view%20displaying%20colorful%20image%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting&width=600&height=600&seq=prod-lg-tv-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 98,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 234,
    createdAt: '2026-01-20',
    tags: ['tv', '4k', 'smart-tvs', 'home-theatre'],
  },
  {
    id: 'p5',
    name: 'Nike Air Force 1 07 White Sneakers - Size 44',
    slug: 'nike-air-force-1-white-size-44',
    description: 'Classic white leather sneakers with timeless style.',
    price: 12999,
    salePrice: 9999,
    sku: 'NIK-AF1-WHT-44',
    stock: 156,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'SneakerHead Kenya',
    brand: 'Nike',
    images: [
      'https://readdy.ai/api/search-image?query=Nike%20Air%20Force%201%2007%20white%20leather%20sneakers%20side%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-nike-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 678,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 3420,
    createdAt: '2026-01-01',
    tags: ['shoes', 'sneakers', 'casual', 'men', 'nike'],
  },
  {
    id: 'p6',
    name: 'Zara Women Floral Summer Dress - Medium',
    slug: 'zara-women-floral-dress-medium',
    description: 'Lightweight cotton floral print dress perfect for summer.',
    price: 7999,
    salePrice: null,
    sku: 'ZAR-FLDR-MED',
    stock: 89,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'Zara',
    images: [
      'https://readdy.ai/api/search-image?query=Floral%20summer%20dress%20on%20hanger%2C%20women%20fashion%2C%20colorful%20flower%20pattern%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting&width=600&height=600&seq=prod-zara-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 124,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 456,
    createdAt: '2026-04-01',
    tags: ['dress', 'women', 'womens-dresses', 'floral', 'summer'],
  },
  {
    id: 'p7',
    name: 'Philips Air Fryer HD9252 - 4.1L Capacity',
    slug: 'philips-air-fryer-hd9252-4l',
    description: 'Rapid Air technology for healthy frying with little to no oil.',
    price: 18999,
    salePrice: 14999,
    sku: 'PHL-HD9252-4L',
    stock: 67,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Philips',
    images: [
      'https://readdy.ai/api/search-image?query=Philips%20air%20fryer%20kitchen%20appliance%20black%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-philips-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 256,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 890,
    createdAt: '2026-02-15',
    tags: ['kitchen', 'air-fryers', 'appliance', 'health', 'cooking'],
  },
  {
    id: 'p8',
    name: 'MacBook Pro 14-inch M3 Pro Chip - 18GB RAM',
    slug: 'macbook-pro-14-m3-pro-18gb',
    description: 'Supercharged by M3 Pro. 14-inch Liquid Retina XDR display.',
    price: 349999,
    salePrice: null,
    sku: 'APL-MBP14-M3P-18',
    stock: 18,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'iStore Kenya',
    brand: 'Apple',
    images: [
      'https://readdy.ai/api/search-image?query=MacBook%20Pro%2014%20inch%20laptop%20silver%20color%20slightly%20open%20showing%20screen%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-macbook-01&orientation=squarish',
    ],
    rating: 4.9,
    reviewCount: 156,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 89,
    createdAt: '2026-01-10',
    tags: ['laptop', 'apple', 'pro'],
  },
  {
    id: 'p9',
    name: 'Hisense 258L Double Door Refrigerator - Silver',
    slug: 'hisense-258l-double-door-fridge-silver',
    description: 'Energy-efficient frost-free refrigerator with adjustable shelves.',
    price: 54999,
    salePrice: 44999,
    sku: 'HSN-258L-DFS',
    stock: 34,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Hisense',
    images: [
      'https://readdy.ai/api/search-image?query=Hisense%20double%20door%20refrigerator%20silver%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-hisense-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 87,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 321,
    createdAt: '2026-03-01',
    tags: ['appliance', 'kitchen', 'cooling'],
  },
  {
    id: 'p10',
    name: 'Oraimo 20000mAh Power Bank - Fast Charge',
    slug: 'oraimo-20000mah-power-bank-fast-charge',
    description: 'High-capacity power bank with dual USB output and LED display.',
    price: 3499,
    salePrice: 2499,
    sku: 'ORM-20K-PB-FC',
    stock: 245,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Oraimo',
    images: [
      'https://readdy.ai/api/search-image?query=Oraimo%20power%20bank%2020000mAh%20black%20color%20with%20LED%20display%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-oraimo-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 5670,
    createdAt: '2026-01-05',
    tags: ['accessory', 'power', 'mobile', 'portable-powerbanks', 'oraimo'],
  },
  {
    id: 'p11',
    name: 'JBL Flip 6 Portable Bluetooth Speaker - Black',
    slug: 'jbl-flip-6-bluetooth-speaker-black',
    description: 'Powerful portable speaker with bold JBL Pro Sound and 12-hour battery.',
    price: 15999,
    salePrice: 11999,
    sku: 'JBL-FLIP6-BLK',
    stock: 112,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'AudioWorld Kenya',
    brand: 'JBL',
    images: [
      'https://readdy.ai/api/search-image?query=JBL%20Flip%206%20portable%20bluetooth%20speaker%20black%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-jbl-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 445,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1890,
    createdAt: '2026-02-20',
    tags: ['speaker', 'bluetooth', 'audio'],
  },
  {
    id: 'p12',
    name: 'Dell Inspiron 15 3520 - Intel Core i5, 16GB RAM',
    slug: 'dell-inspiron-15-i5-16gb',
    description: 'Reliable everyday laptop with 15.6-inch FHD display and SSD storage.',
    price: 84999,
    salePrice: 72999,
    sku: 'DLL-INS15-I5-16',
    stock: 45,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Dell',
    images: [
      'https://readdy.ai/api/search-image?query=Dell%20Inspiron%2015%20laptop%20silver%20color%20slightly%20open%20showing%20keyboard%20and%20screen%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting&width=600&height=600&seq=prod-dell-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 167,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 534,
    createdAt: '2026-03-05',
    tags: ['laptop', 'dell', 'student'],
  },
  {
    id: 'p13',
    name: 'L Oreal Paris Revitalift Anti-Aging Day Cream',
    slug: 'loreal-revitalift-anti-aging-cream',
    description: 'Dermatologically tested anti-wrinkle cream with SPF 30.',
    price: 2499,
    salePrice: 1899,
    sku: 'LOR-REV-50ML',
    stock: 189,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: "L'Oreal",
    images: [
      'https://readdy.ai/api/search-image?query=L%20Oreal%20Paris%20Revitalift%20anti%20aging%20day%20cream%20jar%20red%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-loreal-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 312,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-01-25',
    tags: ['skincare', 'face-care', 'anti-aging', 'beauty', 'women'],
  },
  {
    id: 'p14',
    name: 'Adidas Ultraboost 22 Running Shoes - Size 42',
    slug: 'adidas-ultraboost-22-size-42',
    description: 'Responsive running shoes with Boost midsole for maximum energy return.',
    price: 18999,
    salePrice: 14999,
    sku: 'ADS-UB22-42',
    stock: 78,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'SneakerHead Kenya',
    brand: 'Adidas',
    images: [
      'https://readdy.ai/api/search-image?query=Adidas%20Ultraboost%2022%20running%20shoes%20black%20and%20white%20colorway%20side%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-adidas-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 534,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1670,
    createdAt: '2026-02-01',
    tags: ['shoes', 'running', 'sports', 'sneakers', 'adidas', 'men'],
  },
  {
    id: 'p15',
    name: 'Samsung 6.5kg Top Load Washing Machine - White',
    slug: 'samsung-6-5kg-top-load-washing-machine',
    description: 'Efficient washing with Magic Filter and Eco Tub Clean technology.',
    price: 42999,
    salePrice: 34999,
    sku: 'SAM-WA65-TL',
    stock: 28,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%20top%20load%20washing%20machine%20white%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-samsung-wash-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 134,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 456,
    createdAt: '2026-03-15',
    tags: ['appliance', 'washing-machines', 'home', 'laundry'],
  },
  {
    id: 'p16',
    name: 'HP DeskJet 2720 All-in-One Printer - Wireless',
    slug: 'hp-deskjet-2720-all-in-one-printer',
    description: 'Print, scan, and copy wirelessly from your phone or laptop.',
    price: 8999,
    salePrice: 6999,
    sku: 'HP-DJ2720-WL',
    stock: 156,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'HP',
    images: [
      'https://readdy.ai/api/search-image?query=HP%20DeskJet%20all%20in%20one%20printer%20white%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-hp-01&orientation=squarish',
    ],
    rating: 4.1,
    reviewCount: 278,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 1230,
    createdAt: '2026-01-30',
    tags: ['printer', 'office', 'wireless'],
  },
  {
    id: 'p17',
    name: 'Tecno Spark 20 Pro 256GB - Moonlight Black',
    slug: 'tecno-spark-20-pro-256gb',
    description: '108MP portrait camera, 120Hz AMOLED display, 5000mAh battery with 33W fast charging.',
    price: 24999,
    salePrice: 21999,
    sku: 'TEC-SP20P-256-MB',
    stock: 89,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Tecno',
    images: [
      'https://readdy.ai/api/search-image?query=Tecno%20Spark%2020%20Pro%20smartphone%20in%20black%20color%20front%20and%20back%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-tecno-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 215,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1890,
    createdAt: '2026-02-10',
    tags: ['smartphone', 'android', 'budget', 'tecno', 'smartphones'],
  },
  {
    id: 'p18',
    name: 'Xiaomi Redmi Note 13 Pro 512GB - Midnight Black',
    slug: 'xiaomi-redmi-note-13-pro-512gb',
    description: '200MP OIS camera, 1.5K AMOLED 120Hz display, 67W turbo charging, 5100mAh battery.',
    price: 44999,
    salePrice: 39999,
    sku: 'XIA-RN13P-512-MB',
    stock: 56,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Xiaomi',
    images: [
      'https://readdy.ai/api/search-image?query=Xiaomi%20Redmi%20Note%2013%20Pro%20smartphone%20in%20black%20color%20front%20and%20back%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-xiaomi-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 378,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2340,
    createdAt: '2026-02-20',
    tags: ['smartphone', 'android', 'xiaomi', 'smartphones', 'camera'],
  },
  {
    id: 'p19',
    name: 'Samsung Galaxy Tab A9 Plus 11-inch 128GB WiFi',
    slug: 'samsung-galaxy-tab-a9-plus-128gb',
    description: '11-inch TFT display, Snapdragon processor, quad speakers, multi-window support for productivity.',
    price: 34999,
    salePrice: 29999,
    sku: 'SAM-TABA9P-128-WF',
    stock: 42,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%20Galaxy%20Tab%20A9%20Plus%20tablet%20in%20gray%20color%20front%20view%20showing%20screen%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-samsung-tab-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 156,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 780,
    createdAt: '2026-03-01',
    tags: ['tablet', 'android', 'samsung', 'tablets', 'wifi'],
  },
  {
    id: 'p20',
    name: 'Apple iPad 10th Gen 10.9-inch 64GB WiFi - Blue',
    slug: 'apple-ipad-10th-gen-64gb-blue',
    description: 'A14 Bionic chip, 10.9-inch Liquid Retina display, USB-C, all-day battery life.',
    price: 64999,
    salePrice: null,
    sku: 'APL-IPAD10-64-BL',
    stock: 34,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'iStore Kenya',
    brand: 'Apple',
    images: [
      'https://readdy.ai/api/search-image?query=Apple%20iPad%2010th%20generation%20tablet%20in%20blue%20color%20front%20view%20showing%20screen%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ipad-01&orientation=squarish',
    ],
    rating: 4.8,
    reviewCount: 289,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1560,
    createdAt: '2026-01-20',
    tags: ['tablet', 'ios', 'apple', 'tablets', 'wifi'],
  },
  {
    id: 'p21',
    name: 'Samsung 65-inch QLED 4K Smart TV Q70C',
    slug: 'samsung-65-inch-qled-4k-smart-tv-q70c',
    description: 'Quantum HDR, Dolby Atmos, Object Tracking Sound Lite, Gaming Hub with 120Hz refresh rate.',
    price: 149999,
    salePrice: 129999,
    sku: 'SAM-65Q70C-QLED',
    stock: 19,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'TechHub Kenya',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%2065%20inch%20QLED%204K%20smart%20TV%20front%20view%20displaying%20vivid%20colors%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting&width=600&height=600&seq=prod-samsung-tv-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 198,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 567,
    createdAt: '2026-02-05',
    tags: ['tv', '4k', 'qled', 'smart-tvs', 'samsung'],
  },
  {
    id: 'p22',
    name: 'Sony HT-S400 2.1ch Soundbar with Wireless Subwoofer',
    slug: 'sony-ht-s400-soundbar-subwoofer',
    description: '330W total power, S-Force PRO front surround, wireless subwoofer, Bluetooth connectivity.',
    price: 34999,
    salePrice: 28999,
    sku: 'SNY-HTS400-SB',
    stock: 45,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'AudioWorld Kenya',
    brand: 'Sony',
    images: [
      'https://readdy.ai/api/search-image?query=Sony%20soundbar%20with%20wireless%20subwoofer%20black%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-sony-sb-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 134,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 423,
    createdAt: '2026-03-10',
    tags: ['speaker', 'soundbars', 'audio', 'sound-system', 'bluetooth'],
  },
  {
    id: 'p23',
    name: 'Men Classic Fit Oxford Shirt - Sky Blue',
    slug: 'men-classic-fit-oxford-shirt-sky-blue',
    description: 'Premium cotton oxford weave, button-down collar, classic fit perfect for office and casual wear.',
    price: 3499,
    salePrice: 2499,
    sku: 'FAS-OXF-SB-L',
    stock: 234,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'UrbanWear',
    images: [
      'https://readdy.ai/api/search-image?query=Men%20classic%20fit%20oxford%20shirt%20in%20sky%20blue%20color%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-oxford-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 3450,
    createdAt: '2026-01-10',
    tags: ['shirt', 'mens-shirts', 'casual', 'men', 'oxford'],
  },
  {
    id: 'p24',
    name: 'Women Elegant Maxi Dress - Floral Print',
    slug: 'women-elegant-maxi-dress-floral-print',
    description: 'Flowy ankle-length dress with vibrant floral pattern, V-neck and elastic waist for a flattering silhouette.',
    price: 5499,
    salePrice: 3999,
    sku: 'FAS-MAXI-FP-M',
    stock: 167,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'StyleHub',
    images: [
      'https://readdy.ai/api/search-image?query=Women%20elegant%20maxi%20dress%20with%20floral%20print%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-maxi-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 423,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2100,
    createdAt: '2026-03-01',
    tags: ['dress', 'women', 'womens-dresses', 'floral'],
  },
  {
    id: 'p25',
    name: 'Men Slim Fit Stretch Jeans - Dark Indigo',
    slug: 'men-slim-fit-stretch-jeans-dark-indigo',
    description: 'Cotton-stretch blend denim with modern slim fit, comfortable all-day wear, classic 5-pocket design.',
    price: 4499,
    salePrice: 3499,
    sku: 'FAS-JEAN-SL-34',
    stock: 198,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'DenimCo',
    images: [
      'https://readdy.ai/api/search-image?query=Men%20slim%20fit%20stretch%20jeans%20in%20dark%20indigo%20color%20folded%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-jeans-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 4560,
    createdAt: '2026-01-05',
    tags: ['jeans', 'mens-trousers', 'men', 'denim', 'mens-jeans'],
  },
  {
    id: 'p26',
    name: 'ASUS TUF Gaming A15 Laptop - Ryzen 7, 16GB, RTX 4060',
    slug: 'asus-tuf-gaming-a15-ryzen7-rtx4060',
    description: '15.6-inch FHD 144Hz display, AMD Ryzen 7, NVIDIA RTX 4060 8GB, 16GB DDR5 RAM, 512GB SSD.',
    price: 159999,
    salePrice: 139999,
    sku: 'ASU-TUFA15-R7-4060',
    stock: 22,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Asus',
    images: [
      'https://readdy.ai/api/search-image?query=ASUS%20TUF%20Gaming%20laptop%20black%20color%20slightly%20open%20showing%20RGB%20keyboard%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-asus-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 187,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 345,
    createdAt: '2026-02-15',
    tags: ['laptop', 'gaming-laptops', 'asus', 'gaming', 'rtx'],
  },
  {
    id: 'p27',
    name: 'Logitech MX Keys Wireless Keyboard - Graphite',
    slug: 'logitech-mx-keys-wireless-keyboard',
    description: 'Perfect stroke keys with smart illumination, multi-device Bluetooth, USB-C charging, crafted for creators.',
    price: 14999,
    salePrice: 11999,
    sku: 'LOG-MXKEYS-GR',
    stock: 78,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Logitech',
    images: [
      'https://readdy.ai/api/search-image?query=Logitech%20MX%20Keys%20wireless%20keyboard%20in%20graphite%20color%20top%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-logi-kb-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 456,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1200,
    createdAt: '2026-01-15',
    tags: ['keyboard', 'keyboards', 'wireless', 'office', 'accessory'],
  },
  {
    id: 'p28',
    name: 'Logitech G502 X Gaming Mouse - Black',
    slug: 'logitech-g502-x-gaming-mouse',
    description: 'HERO 25K sensor, LIGHTFORCE hybrid switches, 13 programmable controls, adjustable weight system.',
    price: 8999,
    salePrice: 6999,
    sku: 'LOG-G502X-BK',
    stock: 134,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Logitech',
    images: [
      'https://readdy.ai/api/search-image?query=Logitech%20G502%20X%20gaming%20mouse%20black%20color%20angled%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-logi-mouse-01&orientation=squarish',
    ],
    rating: 4.8,
    reviewCount: 678,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-02-01',
    tags: ['mouse', 'mice', 'gaming', 'accessory', 'logitech'],
  },
  {
    id: 'p29',
    name: 'Ramtons 90L Single Door Fridge - Silver',
    slug: 'ramtons-90l-single-door-fridge-silver',
    description: 'Compact fridge perfect for small apartments, energy-efficient with adjustable thermostat and chiller compartment.',
    price: 22999,
    salePrice: 18999,
    sku: 'RAM-90L-SDF-SL',
    stock: 56,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Ramtons',
    images: [
      'https://readdy.ai/api/search-image?query=Ramtons%20single%20door%20refrigerator%20silver%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ramtons-fridge-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 98,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 567,
    createdAt: '2026-03-01',
    tags: ['appliance', 'refrigerators', 'kitchen', 'cooling'],
  },
  {
    id: 'p30',
    name: 'Mika 20L Microwave Oven - White',
    slug: 'mika-20l-microwave-oven-white',
    description: '20-liter capacity, 700W power, 6 cooking presets, defrost function, mechanical timer control.',
    price: 8999,
    salePrice: 6999,
    sku: 'MIK-20L-MW-WH',
    stock: 89,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Mika',
    images: [
      'https://readdy.ai/api/search-image?query=Mika%20microwave%20oven%20white%20color%20front%20view%20with%20door%20slightly%20open%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-mika-mw-01&orientation=squarish',
    ],
    rating: 4.1,
    reviewCount: 234,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1890,
    createdAt: '2026-02-10',
    tags: ['appliance', 'microwaves', 'kitchen', 'cooking'],
  },
  {
    id: 'p31',
    name: 'Nivea Men Deep Impact Face Wash - 100ml',
    slug: 'nivea-men-deep-impact-face-wash',
    description: 'Deep cleansing face wash with mud extract, removes dirt and excess oil without drying skin.',
    price: 899,
    salePrice: 699,
    sku: 'NIV-DIFW-100',
    stock: 345,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Nivea',
    images: [
      'https://readdy.ai/api/search-image?query=Nivea%20Men%20Deep%20Impact%20face%20wash%20tube%20blue%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-nivea-fw-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 5670,
    createdAt: '2026-01-05',
    tags: ['skincare', 'face-care', 'men', 'beauty', 'cleanser'],
  },
  {
    id: 'p32',
    name: 'Garnier SkinActive Micellar Water - 400ml',
    slug: 'garnier-skinactive-micellar-water-400ml',
    description: 'All-in-1 micellar cleansing water, removes makeup, cleanses and soothes skin, suitable for sensitive skin.',
    price: 1499,
    salePrice: 1199,
    sku: 'GAR-MW-400',
    stock: 267,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Garnier',
    images: [
      'https://readdy.ai/api/search-image?query=Garnier%20SkinActive%20Micellar%20Water%20bottle%20pink%20cap%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-garnier-mw-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 1230,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 8900,
    createdAt: '2026-01-10',
    tags: ['skincare', 'face-care', 'cleanser', 'beauty', 'women'],
  },
  {
    id: 'p33',
    name: 'PlayStation 5 Console - Disc Edition',
    slug: 'playstation-5-console-disc-edition',
    description: 'Next-gen gaming with stunning 4K graphics, haptic feedback controller, 825GB SSD for lightning-fast loading.',
    price: 89999,
    salePrice: 79999,
    sku: 'SNY-PS5-DISC',
    stock: 15,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Sony',
    images: [
      'https://readdy.ai/api/search-image?query=PlayStation%205%20console%20disc%20edition%20white%20color%20standing%20vertical%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ps5-01&orientation=squarish',
    ],
    rating: 4.9,
    reviewCount: 567,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-01-20',
    tags: ['console', 'gaming', 'playstation', 'ps5', 'sony'],
  },
  {
    id: 'p34',
    name: 'FC 25 Standard Edition - PS5 Game',
    slug: 'fc-25-standard-edition-ps5-game',
    description: 'The worlds game with HyperMotionV technology, enhanced tactics, and 5v5 Rush mode for the ultimate football experience.',
    price: 6999,
    salePrice: 5499,
    sku: 'EA-FC25-PS5',
    stock: 123,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'EA Sports',
    images: [
      'https://readdy.ai/api/search-image?query=FC%2025%20Standard%20Edition%20PS5%20game%20case%20front%20cover%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-fc25-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 2100,
    createdAt: '2026-04-01',
    tags: ['game', 'gaming', 'ps5-games', 'sports', 'football'],
  },
  {
    id: 'p35',
    name: 'Xbox Wireless Controller - Carbon Black',
    slug: 'xbox-wireless-controller-carbon-black',
    description: 'Ergonomic design with textured grip, hybrid D-pad, share button, Bluetooth for Xbox Series X|S and PC.',
    price: 7999,
    salePrice: 6499,
    sku: 'MS-XBOX-CTRL-BK',
    stock: 78,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Microsoft',
    images: [
      'https://readdy.ai/api/search-image?query=Xbox%20wireless%20controller%20carbon%20black%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-xbox-ctrl-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 234,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1560,
    createdAt: '2026-02-01',
    tags: ['controller', 'controllers', 'gaming', 'xbox', 'accessory'],
  },
  {
    id: 'p36',
    name: 'Beko 7kg Front Load Washing Machine - White',
    slug: 'beko-7kg-front-load-washing-machine',
    description: 'Energy Class A+++, 15 quick wash programs, delay timer, child lock, silent inverter motor.',
    price: 59999,
    salePrice: 49999,
    sku: 'BEK-7KG-FL-WH',
    stock: 34,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Beko',
    images: [
      'https://readdy.ai/api/search-image?query=Beko%20front%20load%20washing%20machine%20white%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-beko-wash-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 156,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 678,
    createdAt: '2026-03-01',
    tags: ['appliance', 'washing-machines', 'home', 'laundry'],
  },
  {
    id: 'p37',
    name: 'Nunix 1.8L Electric Kettle - Stainless Steel',
    slug: 'nunix-1-8l-electric-kettle-stainless-steel',
    description: 'Rapid boil with auto shut-off, 360-degree swivel base, cordless serving, 1500W heating element.',
    price: 2499,
    salePrice: 1799,
    sku: 'NUN-1.8L-EK-SS',
    stock: 234,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Nunix',
    images: [
      'https://readdy.ai/api/search-image?query=Nunix%20electric%20kettle%20stainless%20steel%20finish%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-nunix-kettle-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-01-15',
    tags: ['appliance', 'kitchen', 'kettle', 'cooking'],
  },
  {
    id: 'p38',
    name: 'Gaming Ergonomic Office Chair - Black & Red',
    slug: 'gaming-ergonomic-office-chair-black-red',
    description: 'High-back design with lumbar support, adjustable armrests, 180-degree recline, premium PU leather.',
    price: 24999,
    salePrice: 19999,
    sku: 'FUR-GMCH-BR',
    stock: 45,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'ComfortMax',
    images: [
      'https://readdy.ai/api/search-image?query=Gaming%20ergonomic%20office%20chair%20black%20and%20red%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-gaming-chair-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 312,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1230,
    createdAt: '2026-03-15',
    tags: ['furniture', 'chair', 'gaming-chair', 'office-chairs', 'gaming'],
  },
  {
    id: 'p39',
    name: 'Pampers Baby-Dry Pants Size 4 - Pack of 56',
    slug: 'pampers-baby-dry-pants-size-4-pack-56',
    description: 'Up to 12 hours of dryness, all-around stretchy waistband, instant absorption for leak-free nights.',
    price: 2499,
    salePrice: 1999,
    sku: 'PAM-BDP4-56',
    stock: 345,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Pampers',
    images: [
      'https://readdy.ai/api/search-image?query=Pampers%20Baby%20Dry%20pants%20diapers%20size%204%20pack%20front%20view%20green%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-pampers-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 1230,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 8900,
    createdAt: '2026-01-05',
    tags: ['baby', 'diapers', 'diaper', 'baby-care', 'disposable-diapers'],
  },
  {
    id: 'p40',
    name: 'Oral-B Pro 3 Electric Toothbrush with Pressure Control',
    slug: 'oral-b-pro-3-electric-toothbrush',
    description: '3D cleaning action, pressure sensor, 3 brushing modes, 2-minute timer, compatible with all Oral-B brush heads.',
    price: 5999,
    salePrice: 4499,
    sku: 'ORB-PRO3-ET',
    stock: 89,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Oral-B',
    images: [
      'https://readdy.ai/api/search-image?query=Oral%20B%20Pro%203%20electric%20toothbrush%20white%20and%20blue%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-oralb-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1670,
    createdAt: '2026-02-10',
    tags: ['health', 'personal-care', 'beauty', 'oral'],
  },
  {
    id: 'p41',
    name: 'Men Genuine Leather Biker Jacket - Black',
    slug: 'men-genuine-leather-biker-jacket-black',
    description: 'Premium genuine leather with quilted lining, asymmetrical zip closure, snap lapels and zippered cuffs for a timeless biker look.',
    price: 8999,
    salePrice: 6499,
    sku: 'FAS-LJ-BK-L',
    stock: 56,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'LeatherCraft',
    images: [
      'https://readdy.ai/api/search-image?query=Mens%20genuine%20leather%20biker%20jacket%20in%20black%20color%20front%20view%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-jacket-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 178,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 890,
    createdAt: '2026-02-10',
    tags: ['jacket', 'mens-jackets', 'leather', 'men'],
  },
  {
    id: 'p42',
    name: 'Men Slim Fit 2-Piece Suit - Navy Blue',
    slug: 'men-slim-fit-2-piece-suit-navy-blue',
    description: 'Modern slim fit two-button suit in premium wool blend, includes matching jacket and trousers, perfect for business and formal events.',
    price: 12999,
    salePrice: 9999,
    sku: 'FAS-SUIT-NB-42',
    stock: 34,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'FormalEdge',
    images: [
      'https://readdy.ai/api/search-image?query=Mens%20slim%20fit%20two%20piece%20suit%20in%20navy%20blue%20color%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-suit-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 98,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 432,
    createdAt: '2026-03-01',
    tags: ['suit', 'mens-suits', 'formal', 'men'],
  },
  {
    id: 'p43',
    name: 'Women Silk Blend Blouse - Ivory White',
    slug: 'women-silk-blend-blouse-ivory-white',
    description: 'Elegant silk blend blouse with V-neckline and bishop sleeves, ideal for office and evening occasions.',
    price: 3999,
    salePrice: 2999,
    sku: 'FAS-BLSE-IW-M',
    stock: 89,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'StyleHub',
    images: [
      'https://readdy.ai/api/search-image?query=Womens%20silk%20blend%20blouse%20in%20ivory%20white%20color%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-blouse-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 234,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 789,
    createdAt: '2026-02-15',
    tags: ['blouse', 'womens-tops', 'women', 'formal'],
  },
  {
    id: 'p44',
    name: 'Women High Waist Pencil Skirt - Black',
    slug: 'women-high-waist-pencil-skirt-black',
    description: 'Classic knee-length pencil skirt with stretch cotton blend, back slit for easy movement, professional office wear.',
    price: 2999,
    salePrice: 1999,
    sku: 'FAS-SKRT-BK-M',
    stock: 123,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'StyleHub',
    images: [
      'https://readdy.ai/api/search-image?query=Womens%20high%20waist%20pencil%20skirt%20in%20black%20color%20on%20hanger%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-skirt-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 156,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 678,
    createdAt: '2026-03-10',
    tags: ['skirt', 'womens-skirts', 'women', 'office'],
  },
  {
    id: 'p45',
    name: 'Men Cotton Crew Neck T-Shirt - White',
    slug: 'men-cotton-crew-neck-tshirt-white',
    description: 'Premium combed cotton crew neck t-shirt with reinforced stitching, pre-shrunk fabric, comfortable regular fit for everyday wear.',
    price: 1499,
    salePrice: 999,
    sku: 'FAS-TSH-WH-L',
    stock: 345,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'UrbanWear',
    images: [
      'https://readdy.ai/api/search-image?query=Mens%20cotton%20crew%20neck%20tshirt%20in%20white%20color%20folded%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-tshirt-01&orientation=squarish',
    ],
    rating: 4.1,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-01-05',
    tags: ['tshirt', 'mens-tshirts', 'casual', 'men'],
  },
  {
    id: 'p46',
    name: 'Men Ankle Leather Chelsea Boots - Dark Brown',
    slug: 'men-ankle-leather-chelsea-boots-dark-brown',
    description: 'Handcrafted genuine leather Chelsea boots with elastic side panels, pull tab, and durable rubber sole for smart casual styling.',
    price: 5999,
    salePrice: 4499,
    sku: 'FAS-BOOT-DB-43',
    stock: 67,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'SneakerHead Kenya',
    brand: 'FootPride',
    images: [
      'https://readdy.ai/api/search-image?query=Mens%20ankle%20leather%20Chelsea%20boots%20in%20dark%20brown%20color%20side%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-boots-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 234,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-02-20',
    tags: ['boots', 'shoes', 'leather', 'men'],
  },
  {
    id: 'p47',
    name: 'Women Air Cushion Running Sneakers - Pink',
    slug: 'women-air-cushion-running-sneakers-pink',
    description: 'Lightweight mesh upper with air cushion sole, responsive arch support, breathable lining, perfect for daily runs and workouts.',
    price: 4999,
    salePrice: 3499,
    sku: 'FAS-SNK-PK-38',
    stock: 145,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'SneakerHead Kenya',
    brand: 'RunFlex',
    images: [
      'https://readdy.ai/api/search-image?query=Womens%20air%20cushion%20running%20sneakers%20in%20pink%20color%20side%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-sneakers-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 567,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-03-05',
    tags: ['sneakers', 'shoes', 'running', 'women'],
  },
  {
    id: 'p48',
    name: 'Classic Chronograph Analog Watch - Silver Stainless Steel',
    slug: 'classic-chronograph-analog-watch-silver-steel',
    description: 'Japanese quartz movement, 42mm stainless steel case, sapphire-coated mineral glass, water resistant to 50m, date window display.',
    price: 7999,
    salePrice: 5499,
    sku: 'FAS-WATCH-SS',
    stock: 89,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'TimeMaster',
    images: [
      'https://readdy.ai/api/search-image?query=Classic%20chronograph%20analog%20watch%20with%20silver%20stainless%20steel%20band%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-watch-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 345,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1230,
    createdAt: '2026-01-25',
    tags: ['watches', 'accessory', 'men', 'classic'],
  },
  {
    id: 'p49',
    name: 'Polarized Aviator Sunglasses - Gold Frame',
    slug: 'polarized-aviator-sunglasses-gold-frame',
    description: 'UV400 polarized lenses with gold-tone metal frame, adjustable nose pads, spring hinges, includes protective case and cleaning cloth.',
    price: 2499,
    salePrice: 1799,
    sku: 'FAS-SGL-GF',
    stock: 234,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'SunShade',
    images: [
      'https://readdy.ai/api/search-image?query=Polarized%20aviator%20sunglasses%20with%20gold%20metal%20frame%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-sunglasses-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 1890,
    createdAt: '2026-03-15',
    tags: ['sunglasses', 'accessory', 'summer', 'unisex'],
  },
  {
    id: 'p50',
    name: 'Women Faux Leather Tote Handbag - Tan Brown',
    slug: 'women-faux-leather-tote-handbag-tan-brown',
    description: 'Spacious faux leather tote with multiple interior pockets, magnetic snap closure, dual top handles, fits 15-inch laptop.',
    price: 4499,
    salePrice: 2999,
    sku: 'FAS-HBAG-TB',
    stock: 78,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'BagStyle',
    images: [
      'https://readdy.ai/api/search-image?query=Womens%20faux%20leather%20tote%20handbag%20in%20tan%20brown%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-handbag-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 278,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1340,
    createdAt: '2026-02-05',
    tags: ['handbags', 'bag', 'women', 'accessory'],
  },
  {
    id: 'p51',
    name: 'Travel Laptop Backpack - 40L Expandable',
    slug: 'travel-laptop-backpack-40l-expandable',
    description: 'Water-resistant backpack with padded laptop compartment, USB charging port, anti-theft pocket, luggage strap, ergonomic shoulder straps.',
    price: 3499,
    salePrice: 2499,
    sku: 'FAS-BP-40L-GR',
    stock: 167,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'TrekGear',
    images: [
      'https://readdy.ai/api/search-image?query=Travel%20laptop%20backpack%2040%20liter%20expandable%20in%20gray%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-backpack-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 567,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3210,
    createdAt: '2026-01-15',
    tags: ['backpacks', 'bag', 'travel', 'laptop'],
  },
  {
    id: 'p52',
    name: 'Vitron 43-inch Full HD LED TV - V43TF',
    slug: 'vitron-43-inch-full-hd-led-tv',
    description: 'Crystal clear Full HD display with built-in digital decoder, HDMI and USB connectivity, wall mountable, energy efficient LED panel.',
    price: 28999,
    salePrice: 23999,
    sku: 'VTR-43LED-V43TF',
    stock: 45,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'TechHub Kenya',
    brand: 'Vitron',
    images: [
      'https://readdy.ai/api/search-image?query=Vitron%2043%20inch%20full%20HD%20LED%20TV%20front%20view%20displaying%20colorful%20image%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ledtv-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1560,
    createdAt: '2026-02-01',
    tags: ['tv', 'led-tvs', '4k', 'smart'],
  },
  {
    id: 'p53',
    name: 'Oraimo FreePods 3 True Wireless Earbuds - Black',
    slug: 'oraimo-freepods-3-wireless-earbuds-black',
    description: 'Active noise cancellation, Bluetooth 5.3, 30-hour total battery life with charging case, IPX5 water resistant, touch controls.',
    price: 4999,
    salePrice: 3499,
    sku: 'ORM-FP3-BK',
    stock: 234,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'AudioWorld Kenya',
    brand: 'Oraimo',
    images: [
      'https://readdy.ai/api/search-image?query=Oraimo%20FreePods%203%20true%20wireless%20earbuds%20in%20black%20color%20with%20charging%20case%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-earbuds-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 890,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-03-01',
    tags: ['earbuds', 'wireless', 'audio', 'bluetooth'],
  },
  {
    id: 'p54',
    name: 'Sony 5.1ch Home Theatre System - 1000W',
    slug: 'sony-5-1ch-home-theatre-system-1000w',
    description: 'Immersive surround sound with 5 speakers and subwoofer, Dolby Digital, Bluetooth streaming, HDMI ARC, 1000W total power output.',
    price: 54999,
    salePrice: 44999,
    sku: 'SNY-HT5.1-1000W',
    stock: 23,
    categoryId: '3',
    categoryName: 'TVs & Audio',
    storeName: 'AudioWorld Kenya',
    brand: 'Sony',
    images: [
      'https://readdy.ai/api/search-image?query=Sony%205%20point%201%20channel%20home%20theatre%20system%20with%20speakers%20and%20subwoofer%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-hometheatre-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 123,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 345,
    createdAt: '2026-01-20',
    tags: ['home-theatre', 'speakers', 'audio', 'sound-system'],
  },
  {
    id: 'p55',
    name: 'Ramtons 200L Chest Freezer - White',
    slug: 'ramtons-200l-chest-freezer-white',
    description: 'Spacious chest freezer with fast freeze function, adjustable thermostat, removable storage basket, energy efficient with low noise operation.',
    price: 34999,
    salePrice: 28999,
    sku: 'RAM-200L-CF-WH',
    stock: 23,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Ramtons',
    images: [
      'https://readdy.ai/api/search-image?query=Ramtons%20200%20liter%20chest%20freezer%20in%20white%20color%20front%20view%20with%20lid%20closed%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-freezer-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 156,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 678,
    createdAt: '2026-03-01',
    tags: ['freezers', 'appliance', 'kitchen', 'cooling'],
  },
  {
    id: 'p56',
    name: 'Nunix 1.5L Glass Jar Blender - 500W',
    slug: 'nunix-1-5l-glass-jar-blender-500w',
    description: 'Powerful 500W motor with pulse function, 1.5L glass jar, stainless steel blades, 2 speed settings, safety lock lid, non-slip base.',
    price: 3499,
    salePrice: 2499,
    sku: 'NUN-BL15-500W',
    stock: 145,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Nunix',
    images: [
      'https://readdy.ai/api/search-image?query=Nunix%201%20point%205%20liter%20glass%20jar%20blender%20with%20500%20watt%20motor%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-blender-01&orientation=squarish',
    ],
    rating: 4.1,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-01-15',
    tags: ['blenders', 'kitchen', 'appliance', 'cooking'],
  },
  {
    id: 'p57',
    name: 'Mika 1.8L Rice Cooker with Steamer - White',
    slug: 'mika-1-8l-rice-cooker-with-steamer-white',
    description: 'Automatic rice cooker with keep-warm function, steaming tray included, non-stick inner pot, measuring cup and spatula included.',
    price: 3999,
    salePrice: 2999,
    sku: 'MIK-RC18-WH',
    stock: 178,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Mika',
    images: [
      'https://readdy.ai/api/search-image?query=Mika%201%20point%208%20liter%20rice%20cooker%20with%20steamer%20white%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ricecooker-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 432,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 2100,
    createdAt: '2026-02-10',
    tags: ['rice-cookers', 'kitchen', 'appliance', 'cooking'],
  },
  {
    id: 'p58',
    name: 'Mika Drip Coffee Maker - 1.5L Glass Carafe',
    slug: 'mika-drip-coffee-maker-1-5l-glass-carafe',
    description: 'Programmable drip coffee maker with auto shut-off, anti-drip system, reusable filter, keep-warm plate, brews up to 12 cups.',
    price: 4999,
    salePrice: 3499,
    sku: 'MIK-CM15',
    stock: 89,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Mika',
    images: [
      'https://readdy.ai/api/search-image?query=Mika%20drip%20coffee%20maker%20with%201%20point%205%20liter%20glass%20carafe%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-coffeemaker-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 234,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-02-20',
    tags: ['coffee-makers', 'kitchen', 'appliance', 'coffee'],
  },
  {
    id: 'p59',
    name: 'Armco 16-inch Standing Fan - 3 Speed',
    slug: 'armco-16-inch-standing-fan-3-speed',
    description: 'Powerful 16-inch oscillating standing fan with 3 speed settings, adjustable height, quiet operation, sturdy base for home and office.',
    price: 3499,
    salePrice: 2499,
    sku: 'ARM-FAN16-3SP',
    stock: 234,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Armco',
    images: [
      'https://readdy.ai/api/search-image?query=Armco%2016%20inch%20standing%20fan%203%20speed%20white%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-fan-01&orientation=squarish',
    ],
    rating: 4.0,
    reviewCount: 678,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-01-10',
    tags: ['fans', 'appliance', 'home', 'cooling'],
  },
  {
    id: 'p60',
    name: 'Roch 2000W Bagless Vacuum Cleaner - Red',
    slug: 'roch-2000w-bagless-vacuum-cleaner-red',
    description: 'Cyclone technology bagless vacuum with HEPA filter, 2L dust capacity, multiple attachments, telescopic tube, suitable for carpets and hard floors.',
    price: 8999,
    salePrice: 6499,
    sku: 'RCH-VC2000-RD',
    stock: 56,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Roch',
    images: [
      'https://readdy.ai/api/search-image?query=Roch%202000%20watt%20bagless%20vacuum%20cleaner%20red%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-vacuum-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 189,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 678,
    createdAt: '2026-03-05',
    tags: ['vacuum-cleaners', 'appliance', 'cleaning', 'home'],
  },
  {
    id: 'p61',
    name: 'Nice & Lovely Anti-Dandruff Shampoo - 500ml',
    slug: 'nice-lovely-anti-dandruff-shampoo-500ml',
    description: 'Formulated with zinc pyrithione and menthol for effective dandruff control, soothes itchy scalp, leaves hair fresh and clean.',
    price: 999,
    salePrice: 749,
    sku: 'NIL-ADS-500',
    stock: 345,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Nice & Lovely',
    images: [
      'https://readdy.ai/api/search-image?query=Nice%20and%20Lovely%20anti%20dandruff%20shampoo%20500ml%20bottle%20green%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-shampoo-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-01-05',
    tags: ['shampoo', 'hair-care', 'beauty', 'health'],
  },
  {
    id: 'p62',
    name: 'Centrum Multivitamin Tablets - Pack of 60',
    slug: 'centrum-multivitamin-tablets-pack-60',
    description: 'Complete daily multivitamin with 24 essential nutrients, supports energy, immunity and overall health for adults.',
    price: 2499,
    salePrice: 1899,
    sku: 'CEN-MVIT-60',
    stock: 234,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Centrum',
    images: [
      'https://readdy.ai/api/search-image?query=Centrum%20multivitamin%20tablets%20pack%20of%2060%20bottle%20white%20and%20green%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-vitamins-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 567,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2340,
    createdAt: '2026-02-15',
    tags: ['vitamins', 'supplements', 'health', 'wellness'],
  },
  {
    id: 'p63',
    name: 'Axe Dark Temptation Body Spray - 150ml',
    slug: 'axe-dark-temptation-body-spray-150ml',
    description: 'Long-lasting deodorant body spray with a rich chocolate and amber fragrance, keeps you fresh for up to 48 hours.',
    price: 899,
    salePrice: 649,
    sku: 'AXE-DT-150',
    stock: 456,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Axe',
    images: [
      'https://readdy.ai/api/search-image?query=Axe%20Dark%20Temptation%20body%20spray%20150ml%20can%20dark%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bodyspray-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 1230,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 6700,
    createdAt: '2026-01-10',
    tags: ['body-sprays', 'fragrance', 'men', 'deodorant'],
  },
  {
    id: 'p64',
    name: "Men Executive Office Desk - 120cm Walnut",
    slug: 'men-executive-office-desk-120cm-walnut',
    description: 'Modern L-shaped executive desk with walnut veneer finish, built-in cable management, metal legs, spacious work surface for home office.',
    price: 18999,
    salePrice: 14999,
    sku: 'FUR-DESK-120-WL',
    stock: 34,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'WorkSpace',
    images: [
      'https://readdy.ai/api/search-image?query=Executive%20office%20desk%20120cm%20walnut%20finish%20with%20metal%20legs%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-desk-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 134,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 456,
    createdAt: '2026-03-10',
    tags: ['desks', 'office-furniture', 'furniture', 'home'],
  },
  {
    id: 'p65',
    name: 'Luxury Cotton Bedsheet Set - Queen Size 4Pcs',
    slug: 'luxury-cotton-bedsheet-set-queen-size-4pcs',
    description: '400 thread count Egyptian cotton bedsheet set, includes 1 flat sheet, 1 fitted sheet, 2 pillowcases, soft breathable fabric for restful sleep.',
    price: 4999,
    salePrice: 3499,
    sku: 'BED-BS-QN-WH',
    stock: 178,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'DreamSoft',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20cotton%20bedsheet%20set%20queen%20size%204%20pieces%20white%20color%20folded%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bedsheet-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 456,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 2100,
    createdAt: '2026-02-01',
    tags: ['bedsheets', 'bedroom', 'home', 'cotton'],
  },
  {
    id: 'p66',
    name: 'Modern LED Table Lamp with USB Charger - White',
    slug: 'modern-led-table-lamp-with-usb-charger-white',
    description: 'Adjustable LED desk lamp with 3 brightness levels, touch control, built-in USB charging port, flexible gooseneck, eye-care technology.',
    price: 2999,
    salePrice: 1999,
    sku: 'LIT-TL-WH',
    stock: 234,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'BrightLife',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20LED%20table%20lamp%20with%20USB%20charger%20white%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-lamp-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 1200,
    createdAt: '2026-03-15',
    tags: ['table-lamps', 'lighting', 'office', 'home'],
  },
  {
    id: 'p67',
    name: 'Blackout Eyelet Curtains Set - 2 Panels Grey',
    slug: 'blackout-eyelet-curtains-set-2-panels-grey',
    description: 'Thermal insulated blackout curtains with silver eyelet rings, blocks 95% of light, noise reducing, energy saving, each panel 140x240cm.',
    price: 4499,
    salePrice: 2999,
    sku: 'DEC-CUR-GR-2P',
    stock: 123,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'HomeStyle',
    images: [
      'https://readdy.ai/api/search-image?query=Blackout%20eyelet%20curtains%20set%202%20panels%20grey%20color%20folded%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-curtains-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 234,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-02-20',
    tags: ['curtains', 'decor', 'home', 'bedroom'],
  },
  {
    id: 'p68',
    name: 'Lenovo ThinkPad E16 Business Laptop - Core i7 16GB',
    slug: 'lenovo-thinkpad-e16-business-laptop-i7-16gb',
    description: '16-inch WUXGA display, Intel Core i7-1355U, 16GB DDR4 RAM, 512GB SSD, fingerprint reader, MIL-STD durability for professionals.',
    price: 129999,
    salePrice: 109999,
    sku: 'LNV-TPE16-I7-16',
    stock: 28,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Lenovo',
    images: [
      'https://readdy.ai/api/search-image?query=Lenovo%20ThinkPad%20E16%20business%20laptop%20black%20color%20slightly%20open%20showing%20keyboard%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bizlaptop-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 98,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 432,
    createdAt: '2026-02-05',
    tags: ['laptop', 'business-laptops', 'computing', 'professional'],
  },
  {
    id: 'p69',
    name: 'Samsung 27-inch Odyssey G5 Gaming Monitor - 144Hz',
    slug: 'samsung-27-inch-odyssey-g5-gaming-monitor-144hz',
    description: '27-inch QHD curved gaming monitor, 144Hz refresh rate, 1ms response time, AMD FreeSync Premium, HDR10 for immersive gaming.',
    price: 44999,
    salePrice: 36999,
    sku: 'SAM-ODYG5-27-144',
    stock: 34,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%2027%20inch%20Odyssey%20G5%20curved%20gaming%20monitor%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-monitor-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 234,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 780,
    createdAt: '2026-03-01',
    tags: ['gaming-monitors', 'monitor', 'computing', 'gaming'],
  },
  {
    id: 'p70',
    name: 'TP-Link Archer AX23 WiFi 6 Router - Dual Band',
    slug: 'tp-link-archer-ax23-wifi-6-router-dual-band',
    description: 'AX1800 dual-band WiFi 6 router, speeds up to 1.8Gbps, OFDMA technology, 4 external antennas, ideal for 4K streaming and gaming.',
    price: 6999,
    salePrice: 4999,
    sku: 'TPL-AX23-WF6',
    stock: 145,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'TP-Link',
    images: [
      'https://readdy.ai/api/search-image?query=TP%20Link%20Archer%20AX23%20WiFi%206%20router%20dual%20band%20black%20color%20with%20antennas%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-router-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1890,
    createdAt: '2026-01-20',
    tags: ['routers', 'networking', 'computing', 'wifi'],
  },
  {
    id: 'p71',
    name: 'Logitech C920 HD Pro Webcam - 1080p',
    slug: 'logitech-c920-hd-pro-webcam-1080p',
    description: 'Full HD 1080p webcam with autofocus, dual stereo microphones, automatic light correction, compatible with all video conferencing platforms.',
    price: 8999,
    salePrice: 6499,
    sku: 'LOG-C920-HD',
    stock: 89,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'Logitech',
    images: [
      'https://readdy.ai/api/search-image?query=Logitech%20C920%20HD%20Pro%20webcam%201080p%20black%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-webcam-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 567,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2340,
    createdAt: '2026-02-10',
    tags: ['webcams', 'accessory', 'computing', 'video'],
  },
  {
    id: 'p72',
    name: 'Nintendo Switch OLED Model - White Joy-Con',
    slug: 'nintendo-switch-oled-model-white-joycon',
    description: '7-inch OLED vibrant screen, 64GB internal storage, enhanced audio, wide adjustable stand, play at home or on the go with detachable Joy-Con controllers.',
    price: 54999,
    salePrice: 47999,
    sku: 'NIN-SW-OLED-WH',
    stock: 18,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Nintendo',
    images: [
      'https://readdy.ai/api/search-image?query=Nintendo%20Switch%20OLED%20model%20with%20white%20Joy%20Con%20controllers%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-nintendo-01&orientation=squarish',
    ],
    rating: 4.8,
    reviewCount: 345,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-02-01',
    tags: ['nintendo', 'console', 'gaming', 'switch'],
  },
  {
    id: 'p73',
    name: 'Redragon K552 Mechanical Gaming Keyboard - RGB Backlit',
    slug: 'redragon-k552-mechanical-gaming-keyboard-rgb',
    description: 'Compact tenkeyless design with Blue switches, rainbow RGB backlighting, aircraft-grade aluminum frame, anti-ghosting keys for competitive gaming.',
    price: 4999,
    salePrice: 3499,
    sku: 'RDG-K552-RGB',
    stock: 156,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Redragon',
    images: [
      'https://readdy.ai/api/search-image?query=Redragon%20K552%20mechanical%20gaming%20keyboard%20RGB%20backlit%20black%20color%20top%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-gamingkb-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 678,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-03-05',
    tags: ['gaming-keyboards', 'keyboard', 'gaming', 'mechanical'],
  },
  {
    id: 'p74',
    name: 'Grand Theft Auto V Premium Edition - PC Game Code',
    slug: 'grand-theft-auto-v-premium-edition-pc-game',
    description: 'The complete GTA V experience including GTA Online, all existing gameplay upgrades and content, digital download code for PC.',
    price: 3999,
    salePrice: 2499,
    sku: 'RST-GTAV-PC',
    stock: 345,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Rockstar Games',
    images: [
      'https://readdy.ai/api/search-image?query=Grand%20Theft%20Auto%20V%20Premium%20Edition%20PC%20game%20key%20card%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-pcgame-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-01-15',
    tags: ['pc-games', 'game', 'gaming', 'pc'],
  },
  {
    id: 'p75',
    name: 'Pearl Basmati Rice - 5kg Premium Aromatic',
    slug: 'pearl-basmati-rice-5kg-premium-aromatic',
    description: 'Premium long-grain aromatic basmati rice, aged for superior taste, perfect for pilau, biryani, and everyday meals, 5kg pack.',
    price: 1899,
    salePrice: 1499,
    sku: 'GRO-RICE-BS-5KG',
    stock: 456,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Pearl',
    images: [
      'https://readdy.ai/api/search-image?query=Pearl%20basmati%20rice%205kg%20pack%20blue%20packaging%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-rice-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 1230,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 7800,
    createdAt: '2026-01-05',
    tags: ['rice-grains', 'food', 'supermarket', 'cooking'],
  },
  {
    id: 'p76',
    name: 'Coca-Cola Soft Drink Can - Pack of 24 x 330ml',
    slug: 'coca-cola-soft-drink-can-pack-24-330ml',
    description: 'Classic Coca-Cola taste in convenient aluminum cans, perfect for parties, gatherings, and everyday refreshment.',
    price: 1899,
    salePrice: 1599,
    sku: 'BEV-COKE-24CAN',
    stock: 567,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Coca-Cola',
    images: [
      'https://readdy.ai/api/search-image?query=Coca%20Cola%20soft%20drink%20can%20pack%20of%2024%20red%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-coke-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 2340,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 12000,
    createdAt: '2026-01-10',
    tags: ['soft-drinks', 'beverage', 'supermarket', 'food'],
  },
  {
    id: 'p77',
    name: 'Snax Mixed Assorted Snacks Gift Box - 20 Packs',
    slug: 'snax-mixed-assorted-snacks-gift-box-20-packs',
    description: 'Assortment of popular Kenyan snacks including crisps, nuts, biscuits, and popcorn, perfect for gifting or office pantry.',
    price: 2499,
    salePrice: 1999,
    sku: 'GRO-SNAX-20PK',
    stock: 234,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Snax',
    images: [
      'https://readdy.ai/api/search-image?query=Snax%20mixed%20assorted%20snacks%20gift%20box%2020%20packs%20colorful%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-snacks-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-01',
    tags: ['snacks', 'food', 'supermarket', 'gift'],
  },
  {
    id: 'p78',
    name: 'Golden Fry Pure Sunflower Cooking Oil - 5 Litres',
    slug: 'golden-fry-pure-sunflower-cooking-oil-5-litres',
    description: 'Pure refined sunflower oil rich in Vitamin E, cholesterol free, ideal for deep frying, baking, and everyday cooking, 5 litre jerrycan.',
    price: 2499,
    salePrice: 2199,
    sku: 'GRO-OIL-SF-5L',
    stock: 345,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Golden Fry',
    images: [
      'https://readdy.ai/api/search-image?query=Golden%20Fry%20pure%20sunflower%20cooking%20oil%205%20litres%20jerrycan%20yellow%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-oil-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 890,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 5600,
    createdAt: '2026-01-20',
    tags: ['cooking-oil', 'food', 'supermarket', 'kitchen'],
  },
  {
    id: 'p79',
    name: 'Chicco Lightweight Baby Stroller - Red',
    slug: 'chicco-lightweight-baby-stroller-red',
    description: 'Ultra-light aluminum frame stroller, one-hand fold mechanism, 5-point safety harness, adjustable canopy, reclining seat, storage basket underneath.',
    price: 14999,
    salePrice: 11999,
    sku: 'BBY-STR-RD',
    stock: 45,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Chicco',
    images: [
      'https://readdy.ai/api/search-image?query=Chicco%20lightweight%20baby%20stroller%20red%20color%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-stroller-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 234,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 780,
    createdAt: '2026-03-01',
    tags: ['strollers', 'baby', 'baby-care', 'gear'],
  },
  {
    id: 'p80',
    name: 'Philips Avent Anti-Colic Baby Bottles - Set of 4',
    slug: 'philips-avent-anti-colic-baby-bottles-set-4',
    description: '260ml anti-colic bottles with AirFree vent, BPA free, natural response nipple, easy to clean wide neck design, suitable from 1 month.',
    price: 3999,
    salePrice: 2999,
    sku: 'BBY-BOT-AV-4PK',
    stock: 123,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Philips Avent',
    images: [
      'https://readdy.ai/api/search-image?query=Philips%20Avent%20anti%20colic%20baby%20bottles%20set%20of%204%20clear%20with%20blue%20caps%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bottles-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 567,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1890,
    createdAt: '2026-02-15',
    tags: ['baby-bottles', 'feeding', 'baby', 'baby-care'],
  },
  {
    id: 'p81',
    name: 'Ingco 650W Electric Power Drill - 13mm Chuck',
    slug: 'ingco-650w-electric-power-drill-13mm-chuck',
    description: 'Variable speed electric drill with 13mm keyless chuck, forward/reverse switch, lock-on button for continuous use, includes auxiliary handle.',
    price: 3999,
    salePrice: 2999,
    sku: 'TLS-PDR650-13',
    stock: 78,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'Ingco',
    images: [
      'https://readdy.ai/api/search-image?query=Ingco%20650%20watt%20electric%20power%20drill%20orange%20and%20black%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-drill-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 234,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 890,
    createdAt: '2026-03-10',
    tags: ['power-tools', 'tools', 'diy', 'industrial'],
  },
  {
    id: 'p82',
    name: 'Hikvision 4MP IP Security Camera - Outdoor IR',
    slug: 'hikvision-4mp-ip-security-camera-outdoor-ir',
    description: '4 megapixel outdoor bullet camera with 30m IR night vision, IP67 weatherproof, PoE support, motion detection, mobile app remote viewing.',
    price: 8999,
    salePrice: 6999,
    sku: 'SEC-CAM-4MP-IR',
    stock: 56,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'Hikvision',
    images: [
      'https://readdy.ai/api/search-image?query=Hikvision%204MP%20IP%20security%20camera%20outdoor%20white%20color%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-camera-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 189,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 567,
    createdAt: '2026-02-20',
    tags: ['security-cameras', 'security', 'outdoor', 'home'],
  },
  {
    id: 'p83',
    name: 'Yoga Mat 6mm Thick Non-Slip Exercise Mat - Purple',
    slug: 'yoga-mat-6mm-non-slip-exercise-mat-purple',
    description: 'Eco-friendly TPE yoga mat with alignment lines, double-sided non-slip texture, lightweight with carrying strap, ideal for yoga pilates and stretching.',
    price: 2499,
    salePrice: 1799,
    sku: 'SPT-YOGA-6MM-PR',
    stock: 234,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'FitPro',
    images: [
      'https://readdy.ai/api/search-image?query=Yoga%20mat%206mm%20thick%20non%20slip%20exercise%20mat%20purple%20color%20rolled%20up%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-yoga-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 456,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2100,
    createdAt: '2026-01-15',
    tags: ['fitness', 'sports', 'exercise', 'yoga'],
  },
  {
    id: 'p84',
    name: 'Yamaha F310 Acoustic Guitar - Natural',
    slug: 'yamaha-f310-acoustic-guitar-natural',
    description: 'Full-size dreadnought acoustic guitar with spruce top, meranti back and sides, rosewood fingerboard, ideal for beginners and intermediate players.',
    price: 14999,
    salePrice: 11999,
    sku: 'MUS-GTR-F310',
    stock: 23,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'Yamaha',
    images: [
      'https://readdy.ai/api/search-image?query=Yamaha%20F310%20acoustic%20guitar%20natural%20wood%20finish%20front%20view%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-guitar-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 178,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 432,
    createdAt: '2026-02-10',
    tags: ['guitars', 'music', 'instrument', 'acoustic'],
  },
  ...extraProducts,
];

export const getFeaturedProducts = (): Product[] =>
  products.filter((p) => p.featured);

export const getFlashDealProducts = (): Product[] =>
  products.filter((p) => p.flashDeal);

export const getProductsByCategory = (categoryId: string): Product[] =>
  products.filter((p) => p.categoryId === categoryId);

export const getTrendingProducts = (): Product[] =>
  [...products].sort((a, b) => b.soldCount - a.soldCount).slice(0, 8);

export const getNewArrivals = (): Product[] =>
  [...products].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).slice(0, 8);

export const getBestSellers = (): Product[] =>
  [...products].sort((a, b) => b.soldCount - a.soldCount).slice(0, 8);